import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { TableBaseStyle, StudySettingStyle } from './StudySettingStyle';
import { STUDY_SET_1 } from './StudySetting';
import StudySettingGridRow from './StudySettingGridRow';
import { useTranslation } from 'react-i18next';

type StudySetting1GridProps = {
  studySet1List: STUDY_SET_1[];
  onChangeData: (targetRow: STUDY_SET_1) => void;
};

const StudySetting1Grid: React.FC<StudySetting1GridProps> = (props) => {
  const tableStyle = TableBaseStyle();
  const studySettingStyle = StudySettingStyle();
  const { t, i18n } = useTranslation();

  return (
    <TableContainer component={Paper} className={studySettingStyle.tableContainer}>
      <Table stickyHeader aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell className={tableStyle.headerCell}>{'No'}</TableCell>
            <TableCell className={tableStyle.headerCell}>{t('StudySetting1Grid.項目','項目')}</TableCell>
            <TableCell className={tableStyle.headerCell}>{t('StudySetting1Grid.演算種別','演算種別')}</TableCell>
            <TableCell className={tableStyle.headerCell}>{t('StudySetting1Grid.軽故障乗数','軽故障乗数')}</TableCell>
            <TableCell className={tableStyle.headerCell}>{t('StudySetting1Grid.重故障乗数','重故障乗数')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.studySet1List.map((row, index) => {
            return (
              <StudySettingGridRow
                studySet1={row}
                rowIndexNo={row.indexNo}
                onChangeData={props.onChangeData}
              ></StudySettingGridRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StudySetting1Grid;
